<template>
    <div class="col-md-12 breadcrumb-app">
        <ul>
            <li v-if="this.$store.state.app.title !== 'Home'">
                <a href="javascript:;">{{this.$store.state.app.title }}</a>
            </li>
            <li v-for="(items, idx) in $store.state.app.breadcrumb" v-bind:key="idx">
                <router-link v-if="items.link" :to="{ name: items.link, query: contractListQuery }">{{ items.name }}</router-link>
                <span v-else>{{ items.name }}</span>
            </li>
        </ul>
        <button v-if="isContractChild" class="contract-back" type="button" @click="backToContractList">
            <i class="ti ti-arrow-left"></i> Back to Contract
        </button>
    </div>
</template>

<script>
export default {
    computed: {
        isContractChild() {
            return this.$route.path.indexOf('/jobcon/') === 0 &&
                this.$route.path !== '/jobcon/contract-data';
        },
        contractListQuery() {
            if (!this.isContractChild) return {};
            const query = Object.assign({}, this.$route.query);
            delete query.contract_id;
            return query;
        }
    },
    methods: {
        backToContractList() {
            this.$router.push({
                name: 'jobcon/contract-data',
                query: this.contractListQuery
            });
        }
    }
};
</script>

<style lang="scss">
    .breadcrumb-app{
        align-items:center;
        display:flex;
        justify-content:space-between;
        padding:3px;
        margin-bottom:30px;
        ul{
            margin:0;
            padding:0;
            li{
                list-style:none;
                float:left;
                padding:0px;
                margin:0px;
                a{
                    color:gray;
                    text-decoration:none;
                }
                span{
                    color:#379dff;
                }
            }
            li:after{
                content:'/';
                color:#dadada;
                padding-left:10px;
                padding-right:10px;
            }
            li:first-child{
                a{
                    cursor:text;
                }
            }
            li:last-child:after{
                content:'';
            }
            li:last-child{
                a{
                    color:#379dff;
                }
            }
        }
        .contract-back{
            background:#fff;
            border:1px solid #dbe4ee;
            border-radius:8px;
            color:#255f9c;
            cursor:pointer;
            font-size:12px;
            font-weight:600;
            padding:8px 13px;
            transition:all .2s ease;
            white-space:nowrap;
            &:hover{
                background:#edf6ff;
                border-color:#9fc5e8;
            }
        }
        @media (max-width: 575px){
            align-items:flex-start;
            flex-direction:column;
            .contract-back{ margin-top:10px; }
        }
    }
</style>
